module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    class: {
      'container': !_vm.isHomePage
    }
  }, [_c('Toasts'), _vm._v(" "), (!_vm.isHomePage) ? _c('MenuBar') : _vm._e(), _vm._v(" "), (_vm.gameModeMultiplayers) ? _c('Chat') : _vm._e(), _vm._v(" "), _c('Alerts'), _vm._v(" "), _c('Modals'), _vm._v(" "), _c('router-view'), _vm._v(" "), (!_vm.isHomePage) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "70px"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4909bde","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = CcdW
// module chunks = 1